import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Plus, Minus } from "lucide-react";

const FAQ = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(0);

  const faqs = [
    { q: t("faq.q1"), a: t("faq.a1") },
    { q: t("faq.q2"), a: t("faq.a2") },
    { q: t("faq.q3"), a: t("faq.a3") },
    { q: t("faq.q4"), a: t("faq.a4") },
    { q: t("faq.q5"), a: t("faq.a5") },
    { q: t("faq.q6"), a: t("faq.a6") },
  ];

  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 border-b border-zinc-200 bg-zinc-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#4F46E5] mb-4">{t("faq.tag")}</p>
          <h2 className="font-display font-black text-4xl md:text-5xl tracking-tighter leading-[0.95]">{t("faq.title")}</h2>
          <p className="mt-6 text-zinc-600">{t("faq.askKoni")}</p>
        </div>

        <div className="md:col-span-8 divide-y divide-zinc-200 border-t border-b border-zinc-200">
          {faqs.map((f, i) => (
            <div key={f.q} data-testid={`faq-${i}`}>
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between text-left py-6 hover:text-[#4F46E5] transition-colors"
                data-testid={`faq-toggle-${i}`}
              >
                <span className="font-display font-bold text-lg md:text-xl pr-4">{f.q}</span>
                {open === i ? <Minus className="w-5 h-5 flex-shrink-0" /> : <Plus className="w-5 h-5 flex-shrink-0" />}
              </button>
              {open === i && <div className="pb-6 text-zinc-600 leading-relaxed">{f.a}</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
